import React, {createRef, useState, useContext} from 'react';
import {useQueryClient} from "react-query";
import {useAuth0} from "@auth0/auth0-react";
import __ from "lodash";
import moment from "moment";
import {withStyles} from "@material-ui/core/styles";
import {Grid, Icon, Tooltip, useTheme} from "@material-ui/core";
import MaterialTable from "@material-table/core";
import {defaultComponentsScroll, MaterialTableBody, FullWidthFilter} from "../../../controls/Material-Table-Components";
import SystemContext from "../../../SystemContext";
import {ColumnWidth} from "../../../blocks/ColumnHelper";
import useDimensions from "../../../blocks/useDimensions";
import {useEmailMessages}from "../../../services/emailMessages";

const LightTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: '#e5e5e5',
    color: 'rgba(0, 0, 0, 0.87)',
    boxShadow: theme.shadows[1],
    fontSize: 12,
    maxWidth: "800px"
  },
}))(Tooltip);

const AddressToolTip = (props) => {
  return (
    <Grid container nowrap="true" key={"address-container"}>
      <Grid item xs={12} nowrap="true" style={{ minWidth: 800 }}><div style={{ display: "inline-block", minWidth: 45, fontWeight: "800", verticalAlign: "top" }}>Sender: </div><div style={{ display: "inline-block", width: 755, textOverflow: "ellipsis" }}>{props.sender}</div></Grid>
      <Grid item xs={12}/>
      <Grid item xs={12} nowrap="true" style={{ minWidth: 800 }}><div style={{ display: "inline-block", minWidth: 45, fontWeight: "800", verticalAlign: "top" }}>To: </div><div style={{ display: "inline-block", width: 755, textOverflow: "ellipsis" }}>{props.toAddress}</div></Grid>
      <Grid item xs={12}/>
      <Grid item xs={12} nowrap="true" style={{ minWidth: 800 }}><div style={{ display: "inline-block", minWidth: 45, fontWeight: "800", verticalAlign: "top" }}>CC: </div><div style={{ display: "inline-block", width: 755, textOverflow: "ellipsis" }}>{props.ccAddress}</div></Grid>
    </Grid>
  );
}


const MessageList = (_props) => {
  const {isAuthenticated} = useAuth0();

  const props = {
    ..._props
  }
  const {classes} = props;

  const [state, setState] = useState({
    activeRow: null,
    selectedIndex: null,
    canEdit: props.canEdit||false,
    multipleSelectionActive: 0,
    direction: "IN"
  });

  let selectedRow = -1;

  const [searchCriteria, setSearchCriteria] = useState();

  const SystemData = useContext(SystemContext);
  const theme = useTheme();
  const eventBus = SystemData.eventBus;

  if (eventBus) {
    eventBus.bind('MessageList.search', (searchCriteria)=> {
      const {fromDate, toDate, messageType, direction, sender, subject, error} = searchCriteria;
      const extraKeys = [];
      extraKeys.push(fromDate??moment().add(-1, "days").startOf("day").format("YYYY-MM-DDHHmmss"));
      extraKeys.push(toDate??moment().endOf("day").format("YYYY-MM-DDHHmmss"));
      extraKeys.push(messageType);
      extraKeys.push(direction);
      extraKeys.push(sender);
      extraKeys.push(subject);
      extraKeys.push(error);
      setSearchCriteria(extraKeys);
      setState({...state, direction: direction})
    });
  }

  const handleRowClick = (event, rowData) => {
    if (rowData.tableData.id >= 0) {
      selectedRow = rowData.tableData.id;
      if (eventBus) {
        if (__.has(rowData, "attachments") && JSON.stringify(rowData.attachments).length > 2) {
          rowData ["hasAttachments"] = true;
        }
        if (rowData.messageSource?.startsWith("CARGOHUB")) {
          try {
            const formattedMessage = JSON.stringify(JSON.parse(rowData.textBody), null, 2);
            rowData.textBody = formattedMessage;
          } catch (err) {
            console.log(err)
          }
        }
        if (props.onChangeSelected && typeof props.onChangeSelected === "function")
          props.onChangeSelected(rowData);
        eventBus.trigger('MessageManagementList.rowSelected', rowData);
      }
    }
  }

  const tableRef = createRef({state: {lastEditingRow: false}});

  const queryClient = useQueryClient();
  let extraKeys = searchCriteria;
  const emailMessages = useEmailMessages({tableRef, queryClient, extraKeys, useCache: false});


  const getColumns = (tableWidth) => {
    const baseColumn = {
      cellStyle: { fontSize:11, padding: "4px 2px" },
      headerStyle: { padding: "4px 2px" },
      filterCellStyle: { padding: "4px 2px" },
      editable: "never",
      sorting: false,
      resizable: false,
    };
    const borderedCellStyle = { fontSize: 11, padding: "8px 1px", borderLeft: "0px solid #f5f5f5", borderRight: "1px solid #f5f5f5" };
    const invisibleBorderedCellStyle = { fontSize: 11, padding: "4px 1px", borderLeft: "0px solid #f5f5f5", borderRight: "1px solid #ffffff" };
    const boldInvisibleBorderedCellStyle = { fontSize: 13, fontWeight: 800, padding: "4px 1px", borderLeft: "0px solid #f5f5f5", borderRight: "1px solid #ffffff" };
    const borderedHeaderStyle = { borderLeft: "0px solid rgb(63, 63, 63)", borderRight: "1px solid rgb(63, 63, 63)" };
    const borderedFilterStyle = {}; //{ borderLeft: "0px solid #ffffff", borderRight: "1px solid #ffffff" };

    return [
      /*
        Can use ...ColumnWidth(70) to generate a fixed width column
      */
      {
        ...baseColumn,
        ...ColumnWidth(100, 1, undefined, {...borderedCellStyle, borderLeft: "1px solid #f5f5f5"}, borderedHeaderStyle, borderedFilterStyle, false),
        title: "Message Date",
        field: "receivedAt",
        filterComponent: FullWidthFilter,
        render: rowData => {
          if (rowData?.tableData?.isScrolling) return (
            <span>{moment(state.direction === "IN" ? rowData.receivedAt : rowData.sentAt).format("DD/MM/YYYY HH:mm")}</span>
          );
          return (<span>{moment(state.direction === "IN" ? rowData.receivedAt : rowData.sentAt).format("DD/MM/YYYY HH:mm")}</span>)
        }
      },
      {
        ...baseColumn,
        ...ColumnWidth(100, 1, undefined, {...borderedCellStyle, borderLeft: "1px solid #f5f5f5"}, borderedHeaderStyle, borderedFilterStyle, false),
        title: "Source",
        field: "messageSource",
        filterComponent: FullWidthFilter,
        render: rowData => {
          if (rowData?.tableData?.isScrolling) return (
            <span>{rowData.messageSource}</span>
          )
          return (
            <span>{rowData.messageSource}</span>
          )
        }
      },
      {
        ...baseColumn,
        ...ColumnWidth(190, 1, undefined, borderedCellStyle, borderedHeaderStyle, borderedFilterStyle, false),
        title: "Sender",
        field: "sender",
        filterComponent: FullWidthFilter,
        render: rowData => {
          if (rowData?.tableData?.isScrolling) return (
            <LightTooltip title={<span style={{whiteSpace: "pre-wrap"}}>`Sender: ${rowData.sender}
              To: ${rowData.toAddress}
              CC: ${rowData.ccAddress}`</span>}>
              <div style={{width:190, maxWidth:190, textOverflow: "ellipsis", whiteSpace:"nowrap", overflow: "hidden"}}>
                {rowData.sender}
              </div>
            </LightTooltip>
          );
          return (
            <LightTooltip title={<AddressToolTip sender={rowData.sender} toAddress={rowData.toAddress} ccAddress={rowData.ccAddress}/>} style={{width:"maxContent", maxWidth:"700px"}}>
              <div style={{width:190, maxWidth:190, textOverflow: "ellipsis", whiteSpace:"nowrap", overflow: "hidden"}}>
                {rowData.sender}
              </div>
            </LightTooltip>
          )
        }
      },
      {
        ...baseColumn,
        ...ColumnWidth(250, 1, undefined, borderedCellStyle, borderedHeaderStyle, borderedFilterStyle, false),
        title: "Subject",
        field: "subject",
        filtering: true,
        filterComponent: FullWidthFilter,
        render: rowData => {
          if (rowData?.tableData?.isScrolling) return (
            <LightTooltip title={rowData.subject}>
              <div style={{width:250, maxWidth:250, textOverflow: "ellipsis", whiteSpace:"nowrap", overflow: "hidden"}}>
                {rowData.subject}
              </div>
            </LightTooltip>
          );
          return (
            <LightTooltip title={rowData.subject}>
              <div style={{width:250, maxWidth:250, textOverflow: "ellipsis", whiteSpace:"nowrap", overflow: "hidden"}}>
                {rowData.subject}
              </div>
            </LightTooltip>
          )
        }
      },
      {
        ...baseColumn,
        ...ColumnWidth(80, 1, undefined, borderedCellStyle, borderedHeaderStyle, borderedFilterStyle, false),
        title: "Status",
        field: "processStatus",
        filterComponent: FullWidthFilter,
      },
      {
        ...baseColumn,
        ...ColumnWidth(180, 1, undefined, borderedCellStyle, borderedHeaderStyle, borderedFilterStyle, false),
        title: "Error",
        field: "error",
        filterComponent: FullWidthFilter,
        render: rowData => {
          if (rowData?.tableData?.isScrolling)
            return (
              <LightTooltip title={rowData.error}>
                <div style={{width:180, maxWidth:180, textOverflow: "ellipsis", whiteSpace:"nowrap", overflow: "hidden"}}>
                  {rowData.error}
                </div>
              </LightTooltip>
          );
          return (
            <LightTooltip title={rowData.error}>
              <div style={{width:180, maxWidth:180, textOverflow: "ellipsis", whiteSpace:"nowrap", overflow: "hidden"}}>
                {rowData.error}
              </div>
            </LightTooltip>
          );
        }
      },
    ];
  };

  const [tableContainerRef, { width: tableWidth, height: tableHeight}] = useDimensions({});

  const theader = tableContainerRef.current?.querySelector('thead');
  const thead = theader ? theader.clientHeight:46;
  const bodyHeight = tableHeight - thead + 20;

  return (isAuthenticated &&
    <div style={{width: "100%", marginLeft: 20, position: "relative"}}>
      <div style={{background: "#ffffff", paddingTop: 16, paddingLeft: 20, paddingRight: 4, nowidth: "calc(100% - 24px)"}}>
        <div ref={tableContainerRef} className={state.canEdit?classes.bookingQueueListEdit:classes.bookingQueueList} style={{width: "100%", minWidth: "100%", height: `calc(100vh - ${props.height + 16}px)`}}>
        <MaterialTable
          icons={{ Filter: React.forwardRef((props, ref) => <Icon className="filterIcon">filter_list</Icon> )}}
          tableRef={tableRef}
          style={{
            border: "none", //"1px solid #aaaaaa",
            boxShadow: "none",
            borderRadius: 0,
          }}
          onRowClick={handleRowClick}
          options={{
            highlightRowStyle: {backgroundColor: "#F69259"},
            actionsColumnIndex: -1,
            cellStyle: {
              padding: "4px 2px",
            },
            filterCellStyle: {
              padding: "4px 2px",
            },
            headerStyle: {
              backgroundColor: theme.palette.tableHeader.backgroundColor,
              color: theme.palette.tableHeader.textColor,
              padding: 2,
            },
            filterRowStyle: {
              paddingLeft:  0,
              width: "100%",
            },
            toolbar: false,
            toolbarButtonAlignment: "right",
            detailPanelType: "single",
            // padding: 'dense',
            paging: false,
            filtering: true,
            search: false,
            searchFieldAlignment: "left",
            columnResizable: false,
          }}
          components={{
            ...defaultComponentsScroll,
            Body: (props) => (
              <MaterialTableBody
                {...props}
                rowHeight={46}
                overscanRowCount={500}
                addVirtualScrolling={true}
                bodyHeight={bodyHeight}
                headerHeight={thead - 8}
                filterRowHeight={50}
              />
            ),
          }}
          localization={{
            header: {
              actions: 'Action'
            },
          }}
          title="Email Messages"
          columns={getColumns(tableWidth)}
          data={emailMessages.data}
        />
        </div>
      </div>
    </div>
  );

}

export default MessageList;
